





























import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const mineModule = namespace('mine')

@Component
export default class AccountInfo extends Vue {
  @mineModule.State('userMsg') userMsg!: any
  uMsg: any = this.$global.uBusinessEntity
  uName: string = this.$global.uName
  uPhone: string = this.$global.uPhone
  mounted() {
    // this.getMsg()
  }
  getMsg() {
    // 获取用户信息
    this.$store.dispatch('mine/getUserMsg', {
      accountId: 42
    })
  }
}
